/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PaginatedURLResponse } from '../models/PaginatedURLResponse';
import type { SortField } from '../models/SortField';
import type { UpdateURLRequest } from '../models/UpdateURLRequest';
import type { URLRequest } from '../models/URLRequest';
import type { URLResponse } from '../models/URLResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class UrlShortenerEndpointsService {
  /**
   * Shorten Url
   * Create a shortened URL from a long URL.
   *
   * Args:
   * url_request (URLRequest): The request containing the URL to shorten and optional short_id
   *
   * Returns:
   * URLResponse: The shortened URL information
   * @param requestBody
   * @returns URLResponse Successful Response
   * @throws ApiError
   */
  public static shortenUrlUrlShortenerApiV1ShortenPost(
    requestBody: URLRequest
  ): CancelablePromise<URLResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/url-shortener/api/v1/shorten',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * List Urls
   * Get a paginated list of all URLs in the database.
   *
   * Args:
   * page (int): Page number (starts from 1)
   * per_page (int): Number of items per page (1-100)
   * sort_by (SortField): Field to sort by
   * sort_desc (bool): Sort in descending order if True
   *
   * Returns:
   * PaginatedURLResponse: Paginated list of URLs with metadata
   * @param page Page number
   * @param perPage Items per page
   * @param sortBy Field to sort by
   * @param sortDesc Sort in descending order
   * @returns PaginatedURLResponse Successful Response
   * @throws ApiError
   */
  public static listUrlsUrlShortenerApiV1UrlsGet(
    page: number = 1,
    perPage: number = 10,
    sortBy: SortField,
    sortDesc: boolean = true
  ): CancelablePromise<PaginatedURLResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/url-shortener/api/v1/urls',
      query: {
        page: page,
        per_page: perPage,
        sort_by: sortBy,
        sort_desc: sortDesc,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Redirect Url
   * Redirect to the original URL for a given short ID.
   * @param shortId
   * @returns any Successful Response
   * @throws ApiError
   */
  public static redirectUrlUrlShortenerApiV1RedirectShortIdGet(
    shortId: string
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/url-shortener/api/v1/redirect/{short_id}',
      path: {
        short_id: shortId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Original Url
   * Retrieve the original URL for a given short ID.
   *
   * Args:
   * short_id (str): The short ID to look up
   *
   * Returns:
   * dict: The original URL information
   * @param shortId
   * @returns any Successful Response
   * @throws ApiError
   */
  public static getOriginalUrlUrlShortenerApiV1ShortIdGet(
    shortId: string
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/url-shortener/api/v1/{short_id}',
      path: {
        short_id: shortId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Delete Url
   * Delete a URL mapping by its short ID.
   *
   * Args:
   * short_id (str): The short ID of the URL to delete
   *
   * Returns:
   * dict: Response containing success status and deleted URL information
   * @param shortId
   * @returns any Successful Response
   * @throws ApiError
   */
  public static deleteUrlUrlShortenerApiV1ShortIdDelete(
    shortId: string
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/url-shortener/api/v1/{short_id}',
      path: {
        short_id: shortId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Update Url
   * Update the URL mapping for an existing short ID.
   * Only updates the URL, keeps the same short ID.
   *
   * Args:
   * short_id (str): The short ID whose URL should be updated
   * update_request (UpdateURLRequest): The new URL to map to this short ID
   *
   * Returns:
   * dict: Response containing success status and updated URL information
   * @param shortId
   * @param requestBody
   * @returns any Successful Response
   * @throws ApiError
   */
  public static updateUrlUrlShortenerApiV1ShortIdPut(
    shortId: string,
    requestBody: UpdateURLRequest
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/url-shortener/api/v1/{short_id}',
      path: {
        short_id: shortId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }
}
